module.exports = __webpack_public_path__ + "img/icon-currency-dollar-decrease.5cd004ad.svg";